var _excluded = ["as", "children", "classes", "className", "color", "iconName", "labelDirection", "size", "disabled", "htmlDisabled"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Icon from "@xo-union/tk-component-icons";
import { useClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "../styles.css";
var DisplayElement = function DisplayElement(_ref) {
  var ComponentToRender = _ref.as,
    children = _ref.children,
    classesProp = _ref.classes,
    className = _ref.className,
    color = _ref.color,
    iconName = _ref.iconName,
    labelDirection = _ref.labelDirection,
    size = _ref.size,
    disabled = _ref.disabled,
    htmlDisabled = _ref.htmlDisabled,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(styles, classesProp);
  var linkClasses = cx(classes['display-link'], color === 'primary' && classes.primary, color === 'primary-alternative' && classes.primaryAlternative, color === 'secondary' && classes.secondary, color === 'tertiary' && classes.tertiary, disabled && classes.disabled, className);
  var tappableAreaClasses = cx(classes['tappable-area'], size === 'md' && classes.md, size === 'lg' && classes.lg, iconName && classes["has-".concat(labelDirection || 'right', "-label")]);
  var disabledProps = disabled ? {
    'aria-disabled': true
  } : {};
  var htmlDisabledProps = htmlDisabled ? {
    disabled: htmlDisabled
  } : {};
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    className: linkClasses
  }, disabledProps, htmlDisabledProps, props), /*#__PURE__*/React.createElement("div", {
    className: tappableAreaClasses
  }, iconName && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    className: classes.icon,
    size: "sm",
    "aria-hidden": "true"
  }), children));
};
DisplayElement.defaultProps = {
  color: 'secondary',
  size: 'lg'
};
process.env.NODE_ENV !== "production" ? DisplayElement.propTypes = {
  /**
   * Component to render
   */
  as: PropTypes.elementType,
  /**
   * The link's content
   */
  children: PropTypes.node,
  /**
   * Class dependencies
   */
  classes: classesPropType(['disabled', 'display-link', 'icon', 'tappable-area']),
  /**
   * Render disabled styles
   */
  disabled: PropTypes.bool,
  /**
   * Set `disabled` html prop
   */
  htmlDisabled: PropTypes.bool,
  /**
   * Class name to append
   */
  className: PropTypes.string,
  /**
   * Color class
   * */
  color: PropTypes.oneOf(['primary', 'primary-alternative', 'secondary', 'tertiary']),
  /**
   * Icon to place next to CTA text
   */
  iconName: PropTypes.string,
  /**
   * Determines whether the link text will be on the left or right side of the icon
   */
  labelDirection: PropTypes.oneOf(['left', 'right']),
  /**
   * Size class
   * */
  size: PropTypes.oneOf(['md', 'lg'])
} : void 0;
export default DisplayElement;